/** Recognise studio UNC addresses; never launch a native protocol or external host. */
export function networkPath(value: string): string | null {
  let path = value.trim();
  if (/^file:\/\//i.test(path)) {
    try { path = decodeURIComponent(path.replace(/^file:/i, '')); } catch { return null; }
  }
  path = path.replace(/\\/g, '/');
  if (!/^\/\/[^/\s]+\/[^/]+/.test(path) || path.length > 4096) return null;
  const parts = path.slice(2).replace(/\/$/, '').split('/');
  if (parts.length < 2 || parts.some(p => !p || p === '.' || p === '..' || /[<>:"|?*]/.test(p) || [...p].some(c => c.charCodeAt(0) < 32))) return null;
  return '\\\\' + parts.join('\\');
}

export function explorerPathHref(path: string): string {
  return '/files?' + new URLSearchParams({ networkPath: path }).toString();
}

export function pathLinkFromClick(target: EventTarget | null): string | null {
  const anchor = target instanceof Element ? target.closest('a[data-network-path]') : null;
  const path = anchor?.getAttribute('data-network-path');
  const valid = path ? networkPath(path) : null;
  return valid ? explorerPathHref(valid) : null;
}

export function linkNetworkPaths(container: HTMLElement) {
  const mark = (anchor: HTMLAnchorElement, path: string) => {
    anchor.href = explorerPathHref(path);
    anchor.dataset.networkPath = path;
    anchor.removeAttribute('target');
    anchor.title = 'Открыть в проводнике Скрепки';
  };
  container.querySelectorAll<HTMLAnchorElement>('a').forEach(anchor => {
    const source = anchor.getAttribute('href') || '';
    const path = networkPath(source) || networkPath(anchor.textContent || '');
    if (path && !anchor.querySelector('img,video,audio')) mark(anchor, path);
  });
  const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
  const nodes: Text[] = [];
  while (walker.nextNode()) nodes.push(walker.currentNode as Text);
  for (const node of nodes) {
    if (node.parentElement?.closest('a,pre,code,script,style')) continue;
    const text = node.textContent || '';
    // Unquoted copied paths may contain spaces; their boundary is the line end.
    const pattern = /(?:\\\\|\/\/)[^\s\\/<>"\r\n]+[\\/][^<>"\r\n]+/g;
    let offset = 0;
    const fragment = document.createDocumentFragment();
    for (const match of text.matchAll(pattern)) {
      // Do not turn the middle of an ordinary https:// URL into a UNC address.
      if (match.index && /[:/\\\w]/.test(text[match.index - 1])) continue;
      const raw = match[0].trimEnd();
      const path = networkPath(raw);
      if (!path) continue;
      fragment.append(document.createTextNode(text.slice(offset, match.index)));
      const anchor = document.createElement('a');anchor.textContent = raw;mark(anchor, path);fragment.append(anchor);
      offset = match.index + raw.length;
    }
    if (offset) { fragment.append(document.createTextNode(text.slice(offset)));node.replaceWith(fragment); }
  }
}
